import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
const WIDTHS = {
  mini: 'max-w-site-mini',
  small: 'max-w-site-small',
  medium: 'max-w-site-medium',
  large: 'max-w-site',
  none: '',
};
type Props = {
  children: ReactNode;
  className?: string;
  id?: string;
  isWide?: boolean;
  size?: 'mini' | 'small' | 'medium' | 'large' | 'none';
};
export const SiteContainer = ({
  children,
  className,
  id,
  isWide,
  size = 'large',
  ...rest
}: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  return isWide ? (
    <div {...rest}>{children}</div>
  ) : (
    <div {...rest} className={classnames('site-container-wrapper w-full px-20', className)} id={id}>
      <div className={classnames('site-container relative mx-auto', WIDTHS[size])}>{children}</div>
    </div>
  );
};
